import { format, isValid, parseISO } from "date-fns";

export const toNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const formatCurrency = (value, currency = "USD") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(toNumber(value));

export const formatInteger = (value) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    toNumber(value),
  );

export const formatDateForApi = (date) => {
  if (!(date instanceof Date) || !isValid(date)) {
    return undefined;
  }
  return format(date, "yyyy-MM-dd");
};

export const formatChartDate = (value, pattern = "MMM dd") => {
  if (!value) return "";
  const parsed = value instanceof Date ? value : parseISO(String(value));
  return isValid(parsed) ? format(parsed, pattern) : String(value);
};
